import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { NavMenuService } from '@root/modules/common/services/nav-menu.service';
import { MenuItem } from '@common/models/menu-item';
import { Router } from '@angular/router';
import { UserSessionInfo } from "@common/models/user-session-info.model";
import { AuthService } from "@common/services/auth.service";
import { NewInvestorService } from "@new-investor/services/new-investor.service";
import * as moment from 'moment';
import { DataHandlerService } from '@root/modules/transactions/services/data-handler.service';
import { HeaderService } from '@common/services/header.service';
import { CommonService } from '../../services/common.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { SocialSharing } from "@ionic-native/social-sharing/ngx";

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
})
export class NavMenuComponent implements OnInit {
  @Output() initiateTransaction = new EventEmitter<{isNewFundOffer:boolean, schemeCode?:string}>(); 
  activeMainTab: string = 'dashboard';
  activeInvestMode:string = 'Start a SIP'; //quick-invest
  toggleTransactTab: boolean = false;
  toggleMoreTab: boolean = false;
  newfundSubMenuIsExpand: boolean = false;

  nfoFund:any;

  public userSessionInfo: UserSessionInfo;
  public investFlow;

  menuItems: MenuItem[] = [
    {
      displayName: 'Dashboard ',
      url: '/investor-dashboard',
      activeTab: 'dashboard',
      icon: 'assets/images/menu-icons/web-menu/Dashboard-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Transact',
      url: '',
      activeTab: 'transact',
      icon: 'assets/images/menu-icons/web-menu/transact-icon.svg',
      disabled:false,
      isExpand:false,
      isChildren:true
    },
    {
      displayName: 'My Portfolio',
      url: 'portfolio',
      activeTab: 'portfolio',
      icon: 'assets/images/menu-icons/web-menu/Portfolio-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Systematic Plans',
      url: 'systematic-plans',
      activeTab: 'systematic-plans',
      icon: 'assets/images/menu-icons/web-menu/Systematic-plans-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Transaction History',
      url: 'transaction-history',
      activeTab: 'transaction-history',
      icon: 'assets/images/menu-icons/web-menu/Transaction-history-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Statements',
      url: 'statements',
      activeTab: 'statements',
      icon: 'assets/images/menu-icons/web-menu/Statements-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'New fund offer',
      url: '',
      activeTab: 'new-fund-offer',
      icon: 'assets/images/menu-icons/web-menu/New-fund-offer-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:true
    },
    {
      displayName: 'Online One Time Bank Mandate Registration',
      url: 'e-mandate',
      activeTab: 'e-mandate',
      icon: 'assets/images/menu-icons/web-menu/eMandate-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Learn & Invest',
      url: '',
      activeTab: 'learn&invest',
      icon: 'assets/images/menu-icons/web-menu/Learn&Invest-con.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Help',
      url: 'help',
      activeTab: 'help',
      icon: 'assets/images/menu-icons/web-menu/Help-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    }

  ]

  menuItemsinMobileFooter: MenuItem[] = [
    {
      displayName: 'Dashboard ',
      url: '/investor-dashboard',
      activeTab: 'dashboard',
      icon: 'assets/images/menu-icons/mobile-menu/Dashboard.png',
      activeIcon: 'assets/images/menu-icons/mobile-menu/dashboard-active.png',
      disabled:false
    },
    {
      displayName: 'My Portfolio',
      url: 'portfolio',
      activeTab: 'portfolio',
      icon: 'assets/images/menu-icons/mobile-menu/portfolio-mobile.png',
      activeIcon: 'assets/images/menu-icons/mobile-menu/Portfolio-active.png',
      disabled:false
    },
    {
      displayName: 'Transact',
      url: 'transaction-history',
      activeTab: 'transact',
      icon: 'assets/images/menu-icons/mobile-menu/transact.png',
      activeIcon: 'assets/images/menu-icons/mobile-menu/Transact-active.png',
      disabled:false
    },
    {
      displayName: 'Systematic Plans',
      url: 'systematic-plans',
      activeTab: 'systematic-plans',
      icon: 'assets/images/menu-icons/mobile-menu/systematic-plan.png',
      activeIcon: 'assets/images/menu-icons/mobile-menu/Systematic-Plans-active.png',
      disabled:false
    },
    {
      displayName: 'More',
      url: '',
      activeTab: 'more',
      icon: 'assets/images/menu-icons/mobile-menu/More_inactive.png',
      activeIcon: 'assets/images/menu-icons/mobile-menu/More_active.png',
      disabled:false
    }
  ]

  menuItemsForMoreTab: MenuItem[] = [
    {
      displayName: 'Transaction History',
      url: 'transaction-history',
      activeTab: 'transaction-history',
      icon: 'assets/images/menu-icons/web-menu/Transaction-history-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Statements',
      url: 'statements',
      activeTab: 'statements',
      icon: 'assets/images/menu-icons/web-menu/Statements-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'New fund offer',
      url: '',
      activeTab: 'new-fund-offer',
      icon: 'assets/images/menu-icons/web-menu/New-fund-offer-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:true
    },
    {
      displayName: 'Online One Time Bank Mandate Registration',
      url: 'e-mandate',
      activeTab: 'e-mandate',
      icon: 'assets/images/menu-icons/web-menu/eMandate-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Learn & Invest',
      url: "",
      activeTab: 'learn&invest',
      icon: 'assets/images/menu-icons/web-menu/Learn&Invest-con.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Help',
      url: 'help',
      activeTab: 'help',
      icon: 'assets/images/menu-icons/web-menu/Help-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'My profile',
      url: 'my-profile',
      activeTab: 'my-profile',
      icon: 'assets/images/menu-icons/web-menu/eMandate-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Help & Support',
      url: '',
      activeTab: 'help&support',
      icon: 'assets/images/menu-icons/web-menu/Help-icon.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Share',
      url: '',
      activeTab: 'socialSharingLink',
      icon: 'assets/images/menu-icons/web-menu/Share.svg',
      disabled:false,
      isExpand:false,
      isChildren:false
    },
    {
      displayName: 'Sign out',
      url: '',
      activeTab: 'sign-out',
      icon: 'assets/images/profile/logout.png',
      disabled:false,
      isExpand:false,
      isChildren:false
    }
  ]
  public transactItems = [
    {
      icon: 'assets/images/investor-dashboard/sip-shape.png',
      transactName : 'Start a SIP'
    },
    {
      icon: 'assets/images/investor-dashboard/lumpsum-menu-icon.svg',
      transactName : 'Invest Lumpsum'
    }
  ]
  activeTabForMore: any;
  profilePicture: string;
  initials: string;
  
  constructor(private navMenuService: NavMenuService, 
              private router: Router, 
              private commonService: CommonService,
              private newInvestorService: NewInvestorService,
              private transactDataHandlerService: DataHandlerService,
              private headerService : HeaderService,
              private iab: InAppBrowser,
              public socialSharing: SocialSharing) { }

  ngOnInit() {
    this.investFlow = AuthService.getInvestFlow();
    // console.log('Invest flow -->', this.investFlow);
    this.getSessionInfo();
    this.getIsTransactTabActive();
    this.navMenuService.getActiveNavMenuTab().subscribe(selectedTab => {
      this.activeMainTab = selectedTab;
    })
    this.navMenuService.getActiveInvestMode().subscribe(selectedTab => {
      this.activeInvestMode = selectedTab;
    })
    this.showNewFundOffer();
    this.getProfilePicture();
  }
  
  transactRoute(item){
    this.activeInvestMode = item.transactName;
    if(item.transactName === 'Invest Lumpsum'){
      this.router.navigate(['/transact/invest-lumpsum'], {queryParams:{schemeCode:  this.nfoFund?.schemeCode}})
    }else{
      this.router.navigate(['/transact/sip-transaction'], {queryParams:{schemeCode:  this.nfoFund?.schemeCode}});
    }
  }
  getSessionInfo() {
    this.userSessionInfo = AuthService.getSessionInfo();
    if(this.userSessionInfo){
      this.userSessionInfo.lastLogin = this.userSessionInfo.lastLogin.replace(' ', 'T');
      this.headerService.setProfilePicture(this.userSessionInfo.image);
    }
  }

  getIsTransactTabActive() {
    this.navMenuService.getIsTransactTabActive().subscribe((resp) => {
      this.toggleTransactTab = resp;
    });
  }

  getProfilePicture() {
    this.headerService.getProfilePicture().subscribe(val=>{
      this.profilePicture = val;
      if(this.userSessionInfo && (!this.profilePicture || this.profilePicture.includes('image/null'))){
          this.initials = this.userSessionInfo["name"].split(' ').slice(0,2).map(name => name[0]).join('').toUpperCase();
      }
    });
  }


  setActiveTab(selectedTab:MenuItem) {
    this.transactDataHandlerService.setResetTransactionJourney(true);
    const isExpand = selectedTab.isExpand;
    this.menuItems.forEach(item =>  item.isExpand = false);
    if(!isExpand){
      selectedTab.isExpand = true;
    }
    if(selectedTab.activeTab === 'transact' || selectedTab.activeTab === 'new-fund-offer'){
      this.initiateTransaction.emit({isNewFundOffer:selectedTab.activeTab === 'new-fund-offer' , schemeCode: this.nfoFund?.schemeCode});
      this.toggleTransactTab = !this.toggleTransactTab;
      this.navMenuService.setIsTransactTabActive(this.toggleTransactTab);
      this.toggleMoreTab = false;
      this.activeTabForMore = '';
    }
    else if (selectedTab.activeTab === 'more') {
      this.toggleTransactTab = false;
      this.toggleMoreTab = !this.toggleMoreTab;
      this.navMenuService.setActiveTransactMenuTab('');
      this.navMenuService.setIsTransactTabActive(this.toggleTransactTab) //transact menu collapsed
      this.getSessionInfo();
    }
    else if(selectedTab.activeTab === 'learn&invest'){
      window.open("https://www.itiamc.com/investors", '_blank');
    }
    else if(selectedTab.activeTab === 'help'){
      this.router.navigate(['/help'])
    }
    else {
      this.router.navigate([selectedTab.url]);
      this.toggleTransactTab = false;
      this.toggleMoreTab = false;
      this.activeTabForMore = '';
      this.navMenuService.setActiveTransactMenuTab('');
      this.navMenuService.setIsTransactTabActive(this.toggleTransactTab) //transact menu collapsed
    }
    this.activeMainTab = selectedTab.activeTab; 
  }

  closeBottomDrawer() {
    this.toggleMoreTab = false;
  }

  setActiveTabForMore(selectedTab:MenuItem) {
    this.activeTabForMore = selectedTab.activeTab; 
    this.toggleMoreTab = false;
    if(selectedTab.activeTab === 'learn&invest'){
      let urlConst = 'https://www.itiamc.com/investors';
      if(this.commonService.getPlatformDetails().isDesktop){
        window.open(urlConst, '_blank');
      }else{
        if(this.commonService.getPlatformDetails().isIosApp || this.commonService.getPlatformDetails().isIPad){
          this.iab.create(urlConst, '_system');
        }else{
          this.iab.create(urlConst, '_system');
        }
      }
    }
    else if(selectedTab.activeTab === 'help'){
      this.router.navigate(['/help'])
    }
    else if(selectedTab.activeTab == 'help&support'){
      let urlHome = 'https://www.itiamc.com/home';
      if(this.commonService.getPlatformDetails().isDesktop){
        window.open(urlHome, '_blank');
      }else{
        if(this.commonService.getPlatformDetails().isIosApp || this.commonService.getPlatformDetails().isIPad){
          this.iab.create(urlHome, '_system');
        }else{
          this.iab.create(urlHome, '_system');
        }
      }
    }
    else if(selectedTab.activeTab == 'socialSharingLink'){
      let appLink = 'https://play.google.com/store/apps/details?id=com.itimf.investorportal' ;
      if(this.commonService.getPlatformDetails().isIosApp || this.commonService.getPlatformDetails().isIPad){
        appLink = 'https://apps.apple.com/us/app/itimf-investor-app/id1611000125';
      }else{
        appLink = 'https://play.google.com/store/apps/details?id=com.itimf.investorportal';
      }
        this.socialSharing
        .share("ITI MF Investor app ", "Shared successfully", "", appLink)
        .then(() => {})
        .catch(() => {
          console.log("Share link failed");
        });
    }
    else if(selectedTab.activeTab === 'sign-out'){
      this.onSignout()
    }
    else {
      this.router.navigate([selectedTab.url]);
    }
  }

  public onSignout(){
    this.headerService.logout().subscribe(
      response => {
        AuthService.logout();
        this.router.navigate(['/login']).then(() => {
        });
      },
      error => {
        console.log(error)
      }
    )
  }

  public showNewFundOffer(){
    this.newInvestorService.getFundDetails({}).subscribe(
      response => {
        if(response.status === 0){
          const fundDetailsList = response.data.returnValue;
          const currentDate = moment().format("YYYY-MM-DD");
          this.nfoFund = fundDetailsList.find((fd) => {
            const toDate = moment(fd.endDate).format("YYYY-MM-DD");
            return fd.isNfo.toLowerCase() === "yes" && toDate >= currentDate;
          });
          this.setNfoMenuState();
        }
      },
      error => {
        this.nfoFund  = null;
        this.setNfoMenuState();
      }
    )
  }

  public setNfoMenuState(){
    const nfoMenu  = this.menuItems.find((i) => i.activeTab === "new-fund-offer");
    const nfoMenuInMore  = this.menuItemsForMoreTab.find((i) => i.activeTab === "new-fund-offer");
    nfoMenu.disabled = !this.nfoFund;
    nfoMenuInMore.disabled = !this.nfoFund;
  }

  public routeToLumpsum() {
    this.router.navigate(['/transact/invest-lumpsum'], {queryParams:{schemeCode:  this.nfoFund?.schemeCode}})
    this.closeBottomDrawer();
  }

  public routeToSip() {
    this.router.navigate(['/transact/sip-transaction'], {queryParams:{schemeCode:  this.nfoFund?.schemeCode}});
    this.closeBottomDrawer();
  }
  
// Mobile submenu
  setActiveTabAndCollapsable(selectedTab:MenuItem){
    this.activeTabForMore = selectedTab.activeTab; 
    this.toggleMoreTab = true;
  }

  menuOpened(selectedTab:MenuItem) {
    this.activeTabForMore = selectedTab.activeTab; 
      this.newfundSubMenuIsExpand = true;
  }
 
  menuClosed() {
    this.newfundSubMenuIsExpand = false;
  }
}
